module.exports = __webpack_public_path__ + "img/hagerup_Det_ene_diktet2.d9986b3e.jpg";